// Screens counted in "Step X of N" from the consultation type question to the shared exclusions (adult, initial or
// transfer). Numbered from this order, like the ED intake counter; a longer route (adolescent, re-initiation) extends N.

export const WEIGHT_SELECTOR_NODE_ID = "aht-sel-type";

export const WEIGHT_ASSESSMENT_MAIN_PATH = [
  "sa-q0-gateway",
  "sa-q2-bmi-capture",
  "sa-q3-consent",
  "sa-q7-bmi-floor",
] as const;

export const WEIGHT_ASSESSMENT_STEP_TOTAL = 1 + WEIGHT_ASSESSMENT_MAIN_PATH.length;
